
import React from 'react';
import ClueList from "@/pages/salesWorkbench/workbenchList/components/clueList";
import CallPublicInfo from "@/pages/publicInfo/call";
import SalePublicInfo from "@/pages/publicInfo/sale";
import DesignPublicInfo from "@/pages/publicInfo/design";
import {getAuthTabs} from "@/utils/auth.ts";

export const clueStatusList = {
  ALL: {
    title: '全部',
    value: 'ALL',
    auth: 'AllTab',
    component: <ClueList query={{status: ''}} listConfigName={'saleWorkBench_ALL'}/>,
  },
  PENDING_DISPATCH_SALE: {
    title: '待派营销',
    value: 'PENDING_DISPATCH_SALE',
    auth: 'saleWorkBenchPendingDispatchSaleTab',
    component: <ClueList query={{pendingDispatchSale: true}}
                          listConfigName={'saleWorkBench_PENDING_DISPATCH_SALE'}/>,
  },
  BEGIN_STATUS: {
    title: '信息',
    value: 'BEGIN_STATUS',
    auth: 'saleWorkBenchClueBeginStatusTab',
    component: <ClueList query={{status: 'BEGIN_STATUS'}} listConfigName={'saleWorkBench_BEGIN_STATUS'}/>,
  },
  CLUE: {
    title: '线索',
    value: 'CLUE',
    auth: 'saleWorkBenchStateClueTab',
    component: <ClueList query={{status: 'CLUE'}} listConfigName={'saleWorkBench_CLUE'}/>,
  },
  SALE_MAN_PENDING: {
    title: '待定线索',
    value: 'SALE_MAN_PENDING',
    auth: 'saleWorkBenchStateCluePendingTab',
    component: <ClueList query={{status: 'SALE_MAN_PENDING'}} listConfigName={'saleWorkBench_SALE_MAN_PENDING'}/>,
  },
  ORDINARY_MSG: {
    title: '有效线索',
    value: 'ORDINARY_MSG',
    auth: 'saleWorkBenchStateVaildClueTab',
    component: <ClueList query={{status: 'ORDINARY_MSG'}} listConfigName={'saleWorkBench_ORDINARY_MSG'}/>,
  },
  VALID_MSG: {
    title: '预约线索',
    value: 'VALID_MSG',
    auth: 'saleWorkBenchStateClueReservationTab',
    component: <ClueList query={{status: 'VALID_MSG'}} listConfigName={'saleWorkBench_VALID_MSG'}/>,
  },
  DESIGN: {
    title: '已转设计',
    value: 'DESIGN',
    auth: 'saleWorkBenchStateClueToDesignTab',
    component: <ClueList query={{status: 'DESIGN'}} listConfigName={'saleWorkBench_DESIGN'}/>,
  },
  TO_SHOP: {
    title: '到店线索',
    value: 'TO_SHOP',
    auth: 'saleWorkBenchStateClueToShopTab',
    component: <ClueList query={{status: 'TO_SHOP'}} listConfigName={'saleWorkBench_TO_SHOP'}/>,
  },
  CALL_USER_PENDING: {
    title: '呼叫待定',
    value: 'CALL_USER_PENDING',
    auth: 'saleWorkBenchClueCallPendingTab',
    component: <ClueList query={{status: 'CALL_USER_PENDING'}} listConfigName={'saleWorkBench_CALL_USER_PENDING'}/>,
  },
  CALL_VALID: {
    title: '呼叫有效',
    value: 'CALL_VALID',
    auth: 'saleWorkBenchClueCallValidTab',
    component: <ClueList query={{status: 'CALL_VALID'}} listConfigName={'saleWorkBench_CALL_VALID'}/>,
  },
  CALL_DISPATCH: {
    title: '呼叫派单',
    value: 'CALL_DISPATCH',
    auth: 'saleWorkBenchClueDispatchTab',
    component: <ClueList
        query={{statusList: ["CLUE", "SALE_MAN_PENDING", "ORDINARY_MSG", "VALID_MSG", "DESIGN", "INVALID", "TO_SHOP"]}}
        listConfigName={'saleWorkBench_CALL_DISPATCH'}/>,
  },
  PUBLIC_SEAT: {
    title: '呼叫公海',
    value: 'PUBLIC_SEAT',
    auth: 'saleWorkBenchPublicSeatTab',
    component: <CallPublicInfo listConfigName={'saleWorkBench_PUBLIC_SEAT'}/>,
  },
  PUBLIC_SALES: {
    title: '营销公海',
    value: 'PUBLIC_SALES',
    auth: 'saleWorkBenchPublicSaleTab',
    component: <SalePublicInfo listConfigName={'saleWorkBench_PUBLIC_SALES'}/>,
  },
  PUBLIC_DESIGN: {
    title: '设计公海',
    value: 'PUBLIC_DESIGN',
    auth: 'saleWorkBenchPublicDesignTab',
    component: <DesignPublicInfo listConfigName={'saleWorkBench_PUBLIC_DESIGN'}/>,
  },
}

export const tabItems = getAuthTabs(Object.values(clueStatusList))
